var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultFalse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 23.5C45 35.3741 35.3741 45 23.5 45C11.6259 45 2 35.3741 2 23.5C2 11.6259 11.6259 2 23.5 2C35.3741 2 45 11.6259 45 23.5ZM47 23.5C47 36.4787 36.4787 47 23.5 47C10.5213 47 0 36.4787 0 23.5C0 10.5213 10.5213 0 23.5 0C36.4787 0 47 10.5213 47 23.5ZM14.7071 13.2929C14.3166 12.9024 13.6834 12.9024 13.2929 13.2929C12.9024 13.6834 12.9024 14.3166 13.2929 14.7071L22.5858 24L13.2929 33.2929C12.9024 33.6834 12.9024 34.3166 13.2929 34.7071C13.6834 35.0976 14.3166 35.0976 14.7071 34.7071L24 25.4142L33.2929 34.7071C33.6834 35.0976 34.3166 35.0976 34.7071 34.7071C35.0976 34.3166 35.0976 33.6834 34.7071 33.2929L25.4142 24L34.7071 14.7071C35.0976 14.3166 35.0976 13.6834 34.7071 13.2929C34.3166 12.9024 33.6834 12.9024 33.2929 13.2929L24 22.5858L14.7071 13.2929Z",
    fill: "#FF3434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFalse);
export default __webpack_public_path__ + "static/media/result_false.5dd5aa0bb388978e5e6c25109ef2675a.svg";
export { ForwardRef as ReactComponent };